import React from "react";
import ApertureMark from "./ApertureMark";
import { LANGUAGE_OPTIONS, UI } from "../../content/site";
import { useLanguage } from "../../i18n/LanguageContext";

// Fixed top bar: the mark (back to top) and the EN / 日本語 toggle. Each option
// is labelled in its own language so either reader can find theirs.
export default function SiteHeader() {
  const { lang, setLang, t } = useLanguage();

  return (
    <header className="dp-header">
      <div className="dp-header__inner">
        <a href="#top" className="dp-header__brand" aria-label={t(UI.home)}>
          <ApertureMark className="dp-header__mark" strokeWidth={32} decorative />
        </a>
        <div className="dp-lang" role="group" aria-label={t(UI.language)}>
          {LANGUAGE_OPTIONS.map((option) => (
            <button
              key={option.id}
              type="button"
              lang={option.id}
              className="dp-lang__option"
              aria-pressed={lang === option.id}
              onClick={() => setLang(option.id)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
